import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Footer } from '@zocdoc/components/src/Layout';

import {
    onServiceEmailClick,
    onServicePhoneClick,
    onLegalLinkClick,
    onSeoLinkClick,
    onKnowledgeBaseClick,
} from '../eventTracking';

export class View extends React.Component {
    static propTypes = {
        onServiceEmailClick: PropTypes.func.isRequired,
        onServicePhoneClick: PropTypes.func.isRequired,
        onSeoLinkClick: PropTypes.func.isRequired,
        onLegalLinkClick: PropTypes.func.isRequired,
        onKnowledgeBaseClick: PropTypes.func.isRequired,
    };

    handleSupportLinkClick = (e, element) => {
        if (element === 'ServicePhone') {
            this.props.onServiceEmailClick();
        } else if (element === 'ServiceEmail') {
            this.props.onServicePhoneClick();
        } else if (element === 'KnowledgeBase') {
            this.props.onKnowledgeBaseClick();
        }
    };

    render() {
        return (
            <Footer
                onLegalLinkClick={this.props.onLegalLinkClick}
                onSeoLinkClick={this.props.onSeoLinkClick}
                onSupportLinkClick={this.handleSupportLinkClick}
            />
        );
    }
}

const mapDispatchToProps = {
    onServiceEmailClick,
    onServicePhoneClick,
    onSeoLinkClick,
    onLegalLinkClick,
    onKnowledgeBaseClick,
};

export default connect(undefined, mapDispatchToProps)(View);
